// @ts-nocheck
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILURE,
  SEND_OTP_REQUEST,
  SEND_OTP_SUCCESS,
  SEND_OTP_FAILURE,
  VERIFY_FORGET_OTP_REQUEST,
  VERIFY_FORGET_OTP_SUCCESS,
  VERIFY_FORGET_OTP_FAILURE,
  REFRESH_TOKEN,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  ALERT_DIALOG,
  ALERT_DIALOG_CLOSE,
  FETCH_USER_PROFILE_DETAILS_REQUEST,
  FETCH_USER_PROFILE_DETAILS_SUCCESS,
  FETCH_USER_PROFILE_DETAILS_FAILURE,
  SET_2FA_REQUEST,
  SET_2FA_SUCCESS,
  SET_2FA_FAILURE,
  REFRESH_USER,
  CHANGE_NOTIFICATION_REQUEST,
  CHANGE_NOTIFICATION_SUCCESS,
  CHANGE_NOTIFICATION_FAILURE,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  UPDATE_IMAGE_REQUEST,
  UPDATE_IMAGE_SUCCESS,
  UPDATE_IMAGE_FAILURE,
  FETCH_CONTRACTOR_PROFILE_REQUEST,
  FETCH_CONTRACTOR_PROFILE_SUCCESS,
  FETCH_CONTRACTOR_PROFILE_FAILURE,
  CHANGE_PUSH_NOTIFICATION_REQUEST,
  CHANGE_PUSH_NOTIFICATION_SUCCESS,
  CHANGE_PUSH_NOTIFICATION_FAILURE,
  TOGGLE_HELP_STATUS,
  ACCEPT_CONTRACTOR_CONSENT_REQUEST,
  ACCEPT_CONTRACTOR_CONSENT_SUCCESS,
  ACCEPT_CONTRACTOR_CONSENT_FAILURE,
  RESET_AUTH,
  UPDATE_EMAIL_PREFERENECE_STATUS_REQUEST,
  UPDATE_EMAIL_PREFERENECE_STATUS_SUCCESS,
  UPDATE_EMAIL_PREFERENECE_STATUS_FAILURE,
  CLIENT_SIGNUP_REQUEST,
  CLIENT_SIGNUP_SUCCESS,
  CLIENT_SIGNUP_FAILURE,
  FETCH_PROFILE_SUCCESS,
  FIREBASE_SUPPORT_STATUS,
  ACCEPT_CONTRACTOR_DOCUMENTS_REQUEST,
  ACCEPT_CONTRACTOR_DOCUMENTS_SUCCESS,
  ACCEPT_CONTRACTOR_DOCUMENTS_FAILURE,
  SWITCH_ACTIVE_ROLE_REQUEST,
  SWITCH_ACTIVE_ROLE_SUCCESS,
  SWITCH_ACTIVE_ROLE_FAILURE,
} from "../constants/auth";
import {
  apiRequest,
  uploadFreelanceProfileImage,
  uploadImage,
} from "../../services/apiService";
import { RESET_CREATE_EVENT_SLICE } from "../constants/createEvent";
import { setupFirebaseCloudMessagingToken } from "../../services/google/firebase/setupFirebaseCloudMessagingToken";
import {
  FCM_TOKEN_REQUEST_COMPLETE,
  FCM_TOKEN_REQUEST_LOADING,
} from "../constants/firebaseReduxConstants";
import { USER_ROLES, userRoles } from "../../staticData/userRoles";
import { GET_SIGNATURE_SUCCESS } from "../constants/contract/contract";
import { isUserRole, isActiveRole } from "../../utils/methods/storeFunc";
import posthog from "posthog-js";

const removeSpecificUserRoleData = (response) => {
  if (response?.data?.data?.userRole === userRoles.contractor) {
    if (response?.data?.data?.contractorProfile) {
      delete response.data.data.contractorProfile;
    }
  }

  return response;
};

function attachUserIdAndNameToPostHog({ response }) {
  const userId = response?.data?.data?.id || response?.data?.data?._id;

  posthog.identify(userId, {
    userId,
    name: response?.data?.data?.name
      ? response?.data?.data?.name
      : response?.data?.data?.fullName
        ? response?.data?.data?.fullName
        : `${response?.data?.data?.firstName} ${response?.data?.data?.lastName}`,
    email: response?.data?.data?.email,
    role: response?.data?.data?.userRole,
  });
}

function resetPosthogSession() {
  // posthog can be in the following states:
  //   - not initialized (no VITE_POSTHOG_KEY) → posthog.reset() = noop, but sessionManager is undefined
  //   - initialized normally → sessionManager exists
  // Guard against both cases so we don't break the login/logout flow.
  try {
    posthog?.reset?.();
  } catch {}
  try {
    posthog?.sessionManager?.resetSessionId?.();
  } catch {}
}

export const loginRequestAction = (
  payload,
  twoFactorCallback,
  successCallback,
  failureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: FCM_TOKEN_REQUEST_LOADING });

    function isNotSafari() {
      const isIos =
        /iPad|iPhone|iPod/.test(navigator.platform) ||
        (navigator.userAgent.includes("Mac") && "ontouchend" in document);

      const isSafari =
        /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
        !window.MSStream;

      return !(isIos || isSafari);
    }
    const deviceTokenSubData = {};

    if (isNotSafari()) {
      try {
        const deviceToken = await Promise.race([
          setupFirebaseCloudMessagingToken(),
          new Promise((_, reject) =>
            setTimeout(() => reject(new Error("FCM timeout")), 5000),
          ),
        ]);
        if (deviceToken) {
          deviceTokenSubData.deviceToken = deviceToken;
        }
      } catch (error) {
        console.warn("FCM token setup failed, continuing without it:", error);
      }
      // const deviceToken = await setupFirebaseCloudMessagingToken();
      //
      // if (deviceToken) {
      //   deviceTokenSubData.deviceToken = deviceToken;
      // }
    }

    dispatch({ type: FCM_TOKEN_REQUEST_COMPLETE });

    dispatch({ type: LOGIN_REQUEST });

    const { response, error } = await apiRequest({
      method: "POST",
      url: "signin",
      data: {
        ...payload,
        ...deviceTokenSubData,
      },
      isToken: false,
    });

    if (response?.status === 200) {
      dispatch({
        type: GET_SIGNATURE_SUCCESS,
        payload: {
          savedText: response?.data?.data?.savedText,
          savedSignature: response?.data?.data?.savedSignature,
        },
      });
      if (response?.data?.data?.isTwoFactorAuthentication !== true) {
        const { inviteContractor } = response?.data?.data || {};
        dispatch({
          type: LOGIN_SUCCESS,
          payload: {
            contractorDetails: {
              contractorProfile: response?.data?.data?.contractorProfile,
              inviteContractor,
            },
            ...removeSpecificUserRoleData(response)?.data,
            deviceToken: deviceTokenSubData?.deviceToken,
          },
        });
        attachUserIdAndNameToPostHog({ response });
        successCallback({
          userData: response?.data?.data,
        });
      } else {
        dispatch({ type: LOGIN_SUCCESS, payload: { token: null } });
        twoFactorCallback();
      }
    } else if (error || response?.status !== 200) {
      dispatch({ type: LOGIN_FAILURE });
      failureCallback(error?.response?.data);
    }
  };
};

export const freelanceLoginRequestAction = (
  payload,
  twoFactorCallback,
  successCallback,
  failureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: FCM_TOKEN_REQUEST_LOADING });

    function isNotSafari() {
      const isIos =
        /iPad|iPhone|iPod/.test(navigator.platform) ||
        (navigator.userAgent.includes("Mac") && "ontouchend" in document);

      const isSafari =
        /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
        !window.MSStream;

      return !(isIos || isSafari);
    }
    const deviceTokenSubData = {};

    if (isNotSafari()) {
      try {
        const deviceToken = await Promise.race([
          setupFirebaseCloudMessagingToken(),
          new Promise((_, reject) =>
            setTimeout(() => reject(new Error("FCM timeout")), 5000),
          ),
        ]);
        if (deviceToken) {
          deviceTokenSubData.deviceToken = deviceToken;
        }
      } catch (error) {
        console.warn("FCM token setup failed, continuing without it:", error);
      }
      // const deviceToken = await setupFirebaseCloudMessagingToken();
      //
      // if (deviceToken) {
      //   deviceTokenSubData.deviceToken = deviceToken;
      // }
    }

    dispatch({ type: FCM_TOKEN_REQUEST_COMPLETE });

    dispatch({ type: LOGIN_REQUEST });

    const { response, error } = await apiRequest({
      method: "POST",
      url: "SignInFreelanceEc",
      data: {
        ...payload,
        ...deviceTokenSubData,
      },
      isToken: false,
    });

    if (response?.status === 200) {
      dispatch({
        type: GET_SIGNATURE_SUCCESS,
        payload: {
          savedText: response?.data?.data?.savedText,
          savedSignature: response?.data?.data?.savedSignature,
        },
      });
      if (response?.data?.data?.isTwoFactorAuthentication !== true) {
        const { inviteContractor } = response?.data?.data || {};
        dispatch({
          type: LOGIN_SUCCESS,
          payload: {
            contractorDetails: {
              contractorProfile: response?.data?.data?.contractorProfile,
              inviteContractor,
            },
            ...removeSpecificUserRoleData(response)?.data,
            deviceToken: deviceTokenSubData?.deviceToken,
          },
        });
        attachUserIdAndNameToPostHog({ response });
        successCallback({
          userData: response?.data?.data,
        });
      } else {
        dispatch({ type: LOGIN_SUCCESS, payload: { token: null } });
        twoFactorCallback();
      }
    } else if (error || response?.status !== 200) {
      dispatch({ type: LOGIN_FAILURE });
      failureCallback(error?.response?.data);
    }
  };
};

export const logoutAction = ({ successCallback, whitelistedReducers }) => {
  return async (dispatch, getState) => {
    const userToken = getState()?.auth?.userToken;
    const deviceToken = getState()?.auth?.deviceToken || null;
    const email = getState()?.auth?.email;

    dispatch({
      type: LOGOUT_REQUEST,
    });

    dispatch({
      type: LOGOUT_SUCCESS,
      payload: {
        whitelistedReducers: whitelistedReducers || [],
      },
    });

    dispatch({
      type: RESET_CREATE_EVENT_SLICE,
    });

    localStorage.removeItem("auth");
    sessionStorage.clear();

    resetPosthogSession();

    if (successCallback) {
      successCallback();
    }

    if (deviceToken && email) {
      await apiRequest({
        method: "POST",
        url: "logout",
        data: {
          deviceToken,
          email,
        },
        isToken: true,
        tempToken: userToken,
      });
    }
  };
};

export const freelanceEcLogoutAction = ({
  successCallback,
  whitelistedReducers,
}) => {
  return async (dispatch, getState) => {
    const deviceToken = getState()?.auth?.deviceToken || null;
    const email = getState()?.auth?.email;

    dispatch({
      type: LOGOUT_REQUEST,
    });

    dispatch({
      type: LOGOUT_SUCCESS,
      payload: {
        whitelistedReducers: whitelistedReducers || [],
      },
    });

    dispatch({
      type: RESET_CREATE_EVENT_SLICE,
    });

    localStorage.removeItem("auth");
    sessionStorage.clear();

    resetPosthogSession();

    if (successCallback) {
      successCallback();
    }

    if (deviceToken && email) {
      await apiRequest({
        method: "POST",
        url: `LogOutFreelanceEc`,
        data: {
          deviceToken,
          email,
        },
        isToken: true,
      });
    }
  };
};

// verify otp
export const verifyOtpRequestAction = (
  payload,
  successCallback,
  faliureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: FCM_TOKEN_REQUEST_LOADING });

    function isNotSafari() {
      const isIos =
        /iPad|iPhone|iPod/.test(navigator.platform) ||
        (navigator.userAgent.includes("Mac") && "ontouchend" in document);

      const isSafari =
        /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
        !window.MSStream;

      return !(isIos || isSafari);
    }
    const deviceTokenSubData = {};

    if (isNotSafari()) {
      try {
        const deviceToken = await Promise.race([
          setupFirebaseCloudMessagingToken(),
          new Promise((_, reject) =>
            setTimeout(() => reject(new Error("FCM timeout")), 5000),
          ),
        ]);
        if (deviceToken) {
          deviceTokenSubData.deviceToken = deviceToken;
        }
      } catch (error) {
        console.warn("FCM token setup failed, continuing without it:", error);
      }
      // const deviceToken = await setupFirebaseCloudMessagingToken();
      //
      // if (deviceToken) {
      //   deviceTokenSubData.deviceToken = deviceToken;
      // }
    }

    dispatch({ type: FCM_TOKEN_REQUEST_COMPLETE });

    dispatch({ type: VERIFY_OTP_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: "verifyOtp",
      data: {
        ...payload,
        ...deviceTokenSubData,
      },
      token: false,
    });
    if (response?.status === 200) {
      dispatch({
        type: VERIFY_OTP_SUCCESS,
        payload: {
          ...response?.data,
          deviceToken: deviceTokenSubData?.deviceToken,
        },
      });
      attachUserIdAndNameToPostHog({ response });
      successCallback
        ? successCallback({
            userData: response?.data?.data,
          })
        : null;
    } else if (error || response?.status !== 200) {
      dispatch({ type: VERIFY_OTP_FAILURE });
      faliureCallback?.(error?.response?.data?.message);
    }
  };
};

// verify otp for freelance
export const freelanceVerifyOtpRequestAction = (
  payload,
  successCallback,
  faliureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: FCM_TOKEN_REQUEST_LOADING });

    function isNotSafari() {
      const isIos =
        /iPad|iPhone|iPod/.test(navigator.platform) ||
        (navigator.userAgent.includes("Mac") && "ontouchend" in document);

      const isSafari =
        /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
        !window.MSStream;

      return !(isIos || isSafari);
    }
    const deviceTokenSubData = {};

    if (isNotSafari()) {
      try {
        const deviceToken = await Promise.race([
          setupFirebaseCloudMessagingToken(),
          new Promise((_, reject) =>
            setTimeout(() => reject(new Error("FCM timeout")), 5000),
          ),
        ]);
        if (deviceToken) {
          deviceTokenSubData.deviceToken = deviceToken;
        }
      } catch (error) {
        console.warn("FCM token setup failed, continuing without it:", error);
      }
      // const deviceToken = await setupFirebaseCloudMessagingToken();
      //
      // if (deviceToken) {
      //   deviceTokenSubData.deviceToken = deviceToken;
      // }
    }

    dispatch({ type: FCM_TOKEN_REQUEST_COMPLETE });

    dispatch({ type: VERIFY_OTP_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: "VerifyOTPFreelanceEc",
      data: {
        ...payload,
        ...deviceTokenSubData,
      },
      token: false,
    });
    if (response?.status === 200) {
      dispatch({
        type: VERIFY_OTP_SUCCESS,
        payload: {
          ...response?.data,
          deviceToken: deviceTokenSubData?.deviceToken,
        },
      });
      attachUserIdAndNameToPostHog({ response });
      successCallback
        ? successCallback({
            userData: response?.data?.data,
          })
        : null;
    } else if (error || response?.status !== 200) {
      dispatch({ type: VERIFY_OTP_FAILURE });
      faliureCallback?.(error?.response?.data?.message);
    }
  };
};

// send otp to email
export const sendOtpRequestAction = (
  payload,
  successCallback,
  failureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: SEND_OTP_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: "generateOtpForgotPassword",
      data: payload,
      isToken: false,
    });
    if (response?.status === 200) {
      dispatch({ type: SEND_OTP_SUCCESS, payload: response?.data?.data });
      successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: SEND_OTP_FAILURE });
      failureCallback();
    }
  };
};

// forget password action
export const forgotPasswordAction = (
  payload,
  successCallback,
  failureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: FORGOT_PASSWORD_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: "generateOtpForgotPassword",
      data: payload,
      isToken: false,
    });
    if (response?.status === 200) {
      // Normalize to string (BE may send userId at the top-level OR body.data._id/data legacy)
      const body = response?.data || {};
      const inner = body.data || {};
      const userIdStr =
        typeof body.userId === "string"
          ? body.userId
          : typeof inner === "string"
            ? inner
            : inner?.userId || inner?._id || inner?.data || null;
      dispatch({
        type: FORGOT_PASSWORD_SUCCESS,
        payload: userIdStr,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FORGOT_PASSWORD_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

// forget password freelance ec action
export const freelanceEcForgotPasswordAction = (
  payload,
  successCallback,
  failureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: FORGOT_PASSWORD_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: "generateOTPForgotPasswordFreelanceEc",
      data: payload,
      isToken: false,
    });
    if (response?.status === 200) {
      // Normalize to string id: BE may send `userId` at the top-level (new) or `data` (legacy)
      const body = response?.data || {};
      const inner = body.data || {};
      const userIdStr =
        typeof body.userId === "string"
          ? body.userId
          : typeof inner === "string"
            ? inner
            : inner?.userId || inner?._id || inner?.data || null;
      dispatch({
        type: FORGOT_PASSWORD_SUCCESS,
        payload: userIdStr,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FORGOT_PASSWORD_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

// verify otp for forget password
export const verifyForgetOtpAction = (
  payload,
  successCallback,
  failureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: VERIFY_FORGET_OTP_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `OtpVerification/${payload?.userId}`,
      data: { otp: payload?.otp },
      isToken: false,
    });
    if (response?.status === 200) {
      dispatch({ type: VERIFY_FORGET_OTP_SUCCESS });
      successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: VERIFY_FORGET_OTP_FAILURE });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

// verify otp for freelance ec forget password
export const freelanceEcVerifyForgetOtpAction = (
  payload,
  successCallback,
  failureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: VERIFY_FORGET_OTP_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `OtpVerificationFreelanceEcForgotPassword/${payload?.userId}`,
      data: { otp: payload?.otp },
      isToken: false,
    });
    if (response?.status === 200) {
      dispatch({ type: VERIFY_FORGET_OTP_SUCCESS });
      successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: VERIFY_FORGET_OTP_FAILURE });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

// refresh token action
export const refreshTokenAction = (payload) => {
  return (dispatch) => {
    dispatch({ type: REFRESH_TOKEN, payload: payload.newToken });
  };
};

// alert dialog action
export const alertDialogAciton = (payload, successCallback) => {
  return (dispatch) => {
    dispatch({ type: ALERT_DIALOG, payload });
    if (successCallback) successCallback();
  };
};

// alert dilog close
export const alertDialogCloseAction = () => {
  return { type: ALERT_DIALOG_CLOSE };
};

// fetch user profile details
export const fetchUserProfileDetailsAction = ({
  url,
  userId,
  version,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({
      type: FETCH_USER_PROFILE_DETAILS_REQUEST,
    });

    const { response, error } = await apiRequest({
      method: "GET",
      url: `${url}/${userId}`,
      isToken: true,
    });

    if (response?.status === 200) {
      // dispatch({ type: VERIFY_FORGET_OTP_SUCCESS });
      dispatch({
        type: FETCH_USER_PROFILE_DETAILS_SUCCESS,
      });
      successCallback
        ? successCallback({
            userData: response?.data?.data,
          })
        : null;
    } else if (response?.status !== 200 || error) {
      failureCallback ? failureCallback() : null;
      dispatch({
        type: FETCH_USER_PROFILE_DETAILS_FAILURE,
      });
    }
  };
};

// fetch user profile details
export const fetchFreelanceUserProfileDetailsAction = ({
  url,
  userId,
  version,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({
      type: FETCH_USER_PROFILE_DETAILS_REQUEST,
    });

    const { response, error } = await apiRequest({
      method: "GET",
      url: `${url}`,
      params: {
        Id: userId,
      },
      isToken: true,
    });

    if (response?.status === 200) {
      // dispatch({ type: VERIFY_FORGET_OTP_SUCCESS });
      dispatch({
        type: FETCH_USER_PROFILE_DETAILS_SUCCESS,
      });
      successCallback
        ? successCallback({
            userData: response?.data?.data,
          })
        : null;
    } else if (response?.status !== 200 || error) {
      failureCallback ? failureCallback() : null;
      dispatch({
        type: FETCH_USER_PROFILE_DETAILS_FAILURE,
      });
    }
  };
};

// fetch contractor profile details
export const fetchContractorProfileDetailsAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_CONTRACTOR_PROFILE_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: `getContractorById/${payload?.contractorId}`,
      isToken: true,
      data: null,
    });

    if (response?.status === 200) {
      dispatch({
        type: FETCH_CONTRACTOR_PROFILE_SUCCESS,
        payload: {
          ...response?.data?.data,
          contractorProfile: {
            isPersonalInformationAdded:
              response?.data?.data?.isPersonalInformationAdded,
            isRoleInformationAdded:
              response?.data?.data?.isRoleInformationAdded,
            isCareerGoalsAdded: response?.data?.data?.isCareerGoalsAdded,
            isContractorFormCompleted:
              response?.data?.data?.isContractorFormCompleted,
          },
        },
      });
      if (successCallback)
        successCallback({
          response,
        });
    } else if (response?.status !== 200 || error) {
      dispatch({
        type: FETCH_CONTRACTOR_PROFILE_FAILURE,
      });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: "Error",
          message: "Failed to fetch user data ",
        },
      });
      if (failureCallback) failureCallback();
    }
  };
};

// set 2FA action
export const set2FAAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch, getState) => {
    dispatch({
      type: SET_2FA_REQUEST,
    });

    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `${isActiveRole(USER_ROLES.FREELANCE_EC) ? "Is2FAFreelanceEc" : "IsTwoFactorAuthentication"}/${getState()?.auth?.userId}`,
      data: payload,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: SET_2FA_SUCCESS,
        payload: response?.data?.data,
      });
      successCallback
        ? successCallback({
            userData: response?.data?.data,
          })
        : null;
    } else if (response?.status !== 200 || error) {
      failureCallback ? failureCallback() : null;
      dispatch({
        type: SET_2FA_FAILURE,
      });
    }
  };
};

// refresh user
export const refreshUserAction = (payload) => {
  return (dispatch) => {
    dispatch({ type: REFRESH_USER, payload });
  };
};

// change email notification prefrence
export const changeNotificationAction = ({
  userId,
  payload,
  successCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: CHANGE_NOTIFICATION_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `emailNotificationPreference/${userId}`,
      data: payload,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: CHANGE_NOTIFICATION_SUCCESS, payload: payload });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: CHANGE_NOTIFICATION_FAILURE });
    }
  };
};

// change push notification prefrence
export const changePushNotificationAction = ({
  userId,
  payload,
  successCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: FCM_TOKEN_REQUEST_LOADING });

    function isNotSafari() {
      const isIos =
        /iPad|iPhone|iPod/.test(navigator.platform) ||
        (navigator.userAgent.includes("Mac") && "ontouchend" in document);

      const isSafari =
        /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
        !window.MSStream;

      return !(isIos || isSafari);
    }
    const deviceTokenSubData = {};

    if (!payload?.deviceToken) {
      try {
        const deviceToken = await Promise.race([
          setupFirebaseCloudMessagingToken(),
          new Promise((_, reject) =>
            setTimeout(() => reject(new Error("FCM timeout")), 5000),
          ),
        ]);
        if (deviceToken) {
          deviceTokenSubData.deviceToken = deviceToken;
        }
      } catch (error) {
        dispatch(
          alertDialogAciton({
            open: true,
            title: "Error",
            message:
              "This device does not support Google Notification Services, which are required for push notifications. You will not be able to receive alerts on this platform. ",
          }),
        );
        return;
      }
    }

    dispatch({ type: FCM_TOKEN_REQUEST_COMPLETE });

    dispatch({ type: CHANGE_PUSH_NOTIFICATION_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: isActiveRole(USER_ROLES.FREELANCE_EC)
        ? "on_off_PushNotificationsFreelanceEc"
        : `on_off_PushNotifications`,
      data: {
        ...payload,
        ...deviceTokenSubData,
      },
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: CHANGE_PUSH_NOTIFICATION_SUCCESS,
        payload: {
          pushNotificationPreference:
            response?.data?.data?.pushNotificationPreference,
          deviceToken: response?.data?.data?.deviceToken,
          currentDeviceToken: deviceTokenSubData?.deviceToken,
        },
      });
      if (successCallback)
        successCallback({
          response,
        });
    } else if (response?.status !== 200 || error) {
      dispatch({ type: CHANGE_PUSH_NOTIFICATION_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message: error?.response?.data?.message,
        }),
      );
    }
  };
};

// change password action
export const changePasswordAction = ({
  userId,
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: CHANGE_PASSWORD_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `${isActiveRole(USER_ROLES.FREELANCE_EC) ? "resetPasswordFreelanceEc" : "resetPassword"}/${userId}`,
      data: payload,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({ type: CHANGE_PASSWORD_SUCCESS });
      if (successCallback) successCallback();
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: "Success",
          message:
            error?.response?.data?.message || "Password changed successfully",
        },
      });
    } else if (response?.status !== 200 || error) {
      dispatch({ type: CHANGE_PASSWORD_FAILURE });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: "Error",
          message:
            error?.response?.data?.message || "Failed to change password",
        },
      });
      if (failureCallback) failureCallback();
    }
  };
};

// update image action
export const UpdateImageAction = ({
  formData,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_IMAGE_REQUEST });
    const { response, error } = await uploadImage({
      formData,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: UPDATE_IMAGE_SUCCESS, payload: response?.data?.urls });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPDATE_IMAGE_FAILURE });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: "Error",
          message: error?.response?.data?.message || "Failed to upload image",
        },
      });
      if (failureCallback) failureCallback();
    }
  };
};

// update freelance profile image action
export const freelanceUpdateImageAction = ({
  formData,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_IMAGE_REQUEST });
    const { response, error } = await uploadFreelanceProfileImage({
      formData,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: UPDATE_IMAGE_SUCCESS, payload: response?.data?.urls });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPDATE_IMAGE_FAILURE });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: "Error",
          message: error?.response?.data?.message || "Failed to upload image",
        },
      });
      if (failureCallback) failureCallback();
    }
  };
};

// toggle help status
export const toggleHelper = (value) => {
  return (dispatch) => {
    dispatch({ type: TOGGLE_HELP_STATUS, payload: value });
  };
};

// accept contracto consent
export const acceptContractorConsentAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: ACCEPT_CONTRACTOR_CONSENT_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: isActiveRole(USER_ROLES.FREELANCE_EC)
        ? "updateSmsStatusFreelanceEc"
        : isActiveRole(USER_ROLES.CONTRACTOR)
          ? "updateContractorSmsStatus"
          : isActiveRole(USER_ROLES.CLIENT)
            ? "updateClientSmsStatus"
            : "updateSmsStatus",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({ type: ACCEPT_CONTRACTOR_CONSENT_SUCCESS });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ACCEPT_CONTRACTOR_CONSENT_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message:
            error?.response?.data?.message ||
            "Failed to accept consent of contractor, please try again!",
        }),
      );
      if (failureCallback) failureCallback();
    }
  };
};

// client signup action
export const clientSignupAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: CLIENT_SIGNUP_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: "addClient",
      data: payload?.data,
      isToken: false,
    });
    if (response?.status === 200) {
      dispatch({ type: CLIENT_SIGNUP_SUCCESS });
      successCallback?.(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      if (error?.response?.data?.canForceAdd) {
        dispatch(
          alertDialogAciton({
            open: true,
            title: "Warning",
            message:
              error?.response?.data?.message ||
              "We have a similar company available.",
            okLabel: "Add Anyway",
            onOk: () => {
              dispatch(
                clientSignupAction({
                  payload: { data: { ...payload?.data, forceAdd: true } },
                  successCallback,
                  failureCallback,
                }),
              );
            },
          }),
        );
        dispatch({ type: CLIENT_SIGNUP_FAILURE });
        return;
      }
      dispatch({ type: CLIENT_SIGNUP_FAILURE });
      failureCallback?.(
        error?.response?.data?.message || "Failed to signup client",
      );
    }
  };
};

// reset auth
export const resetAuthAction = () => {
  return { type: RESET_AUTH };
};

function getUpdateStatusAccToUser(userRole) {
  switch (userRole) {
    case USER_ROLES.CLIENT:
      return "updateEmailPreference";
    case USER_ROLES.CONTRACTOR:
      return "updateContractorEmailPreference";
    case USER_ROLES.COORDINATOR:
      return "updateCoordinatorEmailPreference";
    case USER_ROLES.ADMIN:
      return "updateAdminEmailPreference";
    case USER_ROLES.SUPERADMIN:
      return "updateAdminEmailPreference";
    case USER_ROLES.FREELANCE_EC:
      return "updateFreelanceEcEmailPreference";
    default:
      return "updateEmailPreference";
  }
}


// update email preference status
export const updateEmailPreferenceStatus = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_EMAIL_PREFERENECE_STATUS_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: getUpdateStatusAccToUser(getState()?.auth?.userRole),
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: UPDATE_EMAIL_PREFERENECE_STATUS_SUCCESS,
        payload: response?.data,
      });
      successCallback?.(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPDATE_EMAIL_PREFERENECE_STATUS_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message: error?.response?.data?.message || "Failed to update status",
        }),
      );
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

// get user profile data
export const getUserProfileDataAciton = ({ successCallback }) => {
  return async (dispatch, getState) => {
    const { userToken } = getState()?.auth || { userToken: null };
    if (!userToken) return;
    // Multi-role: use activeRole (current UI) to pick the endpoint, not
    // approvedRoles. A user with freelanceEc + admin accessing as admin should
    // call /getUserProfile, not /getUserProfileFreelanceEc.
    const isFreelanceEcActive = isActiveRole(USER_ROLES.FREELANCE_EC);
    const { response } = await apiRequest({
      method: "GET",
      url: isFreelanceEcActive
        ? "getUserProfileFreelanceEc"
        : "getUserProfile",
      isToken: true,
    });
    if (response?.status === 200) {
      const { inviteContractor } = response?.data?.data || {};
      dispatch({
        type: FETCH_PROFILE_SUCCESS,
        payload: {
          contractorDetails: {
            contractorProfile: response?.data?.data?.contractorProfile,
            inviteContractor,
          },
          ...removeSpecificUserRoleData(response)?.data,
        },
      });

      attachUserIdAndNameToPostHog({ response });
      successCallback?.();
    }
  };
};

/**
 * firebase support status action
 */
export const firebaseSupportStatusAction = (payload) => {
  return { type: FIREBASE_SUPPORT_STATUS, payload };
};

/**
 * accept contractor document action
 * @example
 * api/v5/updateSmsStatus?userId=68c996edf34f81ed7a992a8a
 
Payload
{
    "smsPermissionStatus":true,
    "termsAcceptedAt":true,
    "mobile":"705-181-9135",
    "mediaReleaseConsent":true,
    "mediaReleaseUrl":"https://qodex.ai/all-tools/url-address-generator",
    "paymentTermsConsent":true,
    "paymentTermsUrl":"https://qodex.ai/all-tools/url-address-generator",
    "electronicExecutionConsent":true,
    "electronicExecutionUrl":"https://qodex.ai/all-tools/url-address-generator",
    "independentContractorConsent":true,
    "independentContractorUrl":"https://qodex.ai/all-tools/url-address-generator",
    "backstagePassConsent":true,
    "backstagePassUrl":"https://qodex.ai/all-tools/url-address-generator",
     "textCommunicationConsent":true,
    "textCommunicationUrl":"https://qodex.ai/all-tools/url-address-generator",
    "mediaLegalName":"Malik",
    "paymentLegalName":"Malik1",
    "electronicLegalName":"Malik2",
    "independentLegalName":"Malik3",
    "backstageLegalName":"Malik4",
    "textCommunicationLegalName": "Malik5"
}
 */
export const acceptContractorDocumentAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: ACCEPT_CONTRACTOR_DOCUMENTS_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "updateContractorAgreementStatus",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({ type: ACCEPT_CONTRACTOR_DOCUMENTS_SUCCESS });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ACCEPT_CONTRACTOR_DOCUMENTS_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message:
            error?.response?.data?.message ||
            "Failed to accept consent of contractor, please try again!",
        }),
      );
      if (failureCallback) failureCallback();
    }
  };
};
/**
 * Multi-role: switches the user's active interface. Calls POST /switchActiveRole.
 * Receives a new token+refreshToken, updates localStorage and forces a reload of
 * the SPA (window.location.replace) to rebuild all routes/layouts from the new
 * activeRole — a pragmatic solution that avoids an intermediate state.
 *
 * The backend validates that the requested role is in the user's approvedRoles;
 * if not, it returns 403 and the UI keeps the current role.
 */
export const switchActiveRoleAction = (
  newRole,
  successCallback,
  failureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: SWITCH_ACTIVE_ROLE_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: "switchActiveRole",
      data: { role: newRole },
      isToken: true,
    });

    if (response?.status === 200 || response?.data?.success) {
      const data = response?.data || {};
      dispatch({
        type: SWITCH_ACTIVE_ROLE_SUCCESS,
        payload: {
          token: data.token || data.accessToken,
          refreshToken: data.refreshToken,
          activeRole: data.activeRole,
          approvedRoles: data.approvedRoles,
        },
      });
      successCallback?.();
      // Pragmatic reload to rebuild routes/layouts via the new activeRole
      setTimeout(() => window.location.replace("/"), 150);
    } else {
      const msg =
        error?.response?.data?.message || "Failed to switch role";
      dispatch({ type: SWITCH_ACTIVE_ROLE_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message: msg,
        }),
      );
      failureCallback?.(msg);
    }
  };
};
